import React from 'react';
import { MDBDataTable, MDBPageItem, MDBPageNav, MDBPagination } from 'mdbreact';
import dayjs from 'dayjs';
import { Button } from 'reactstrap';

const columns = [
  {
    label: 'Image',
    field: 'image',
    sort: 'disabled',
    width: 150,
  },
  {
    label: 'Name',
    field: 'name',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'Company',
    field: 'company',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'Category',
    field: 'category',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'Districts',
    field: 'districts',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'Weight/Qty',
    field: 'weight',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'Price',
    field: 'price',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'Show In Ad',
    field: 'showInAd',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'Created At',
    field: 'createdAt',
    sort: 'asc',
    width: 100,
  },
  {
    label: 'Updated At',
    field: 'updatedAt',
    sort: 'asc',
    width: 150,
  },
  {
    label: 'Action',
    field: 'actions',
    sort: 'disabled',
    width: 100,
  },
];
const ProductsList = (props) => {
  return (
    <>
      <MDBDataTable
        btn
        responsive
        bordered
        searching={false}
        paging={false}
        data={{
          columns: columns,
          rows: props?.products?.map((x) => ({
            ...x,
            category: x.khareedariCategory.name,
            districts: x.districts?.map((x) => x.name).join(', '),
            company: x.company.name,
            name: x.name,
            showInAd: x.showInAd ? 'Yes' : 'No',
            weight: x.weight + ' ' + x.unit,
            price: 'Rs ' + x.price,
            image: <img src={x.image} className="rounded-circle avatar-sm card-img" />,

            createdAt: dayjs(x.createdAt).format('DD/MM/YYYY'),
            updatedAt: dayjs(x.createdAt).format('DD/MM/YYYY'),
            actions: (
              <Button color="info" onClick={() => props.editProduct(x)}>
                View
              </Button>
            ),
          })),
        }}
      />
      <MDBPagination className="mb-5 justify-content-center">
        <MDBPageItem disabled={props?.currentPage === 1}>
          <MDBPageNav onClick={props?.handlePrev} className="page-link-custom">
            &laquo;
          </MDBPageNav>
        </MDBPageItem>
        {props?.renderPageNumbers}
        <MDBPageItem disabled={props?.currentPage === props?.pagesAmount}>
          <MDBPageNav onClick={props?.handleNext} className="page-link-custom">
            &raquo;
          </MDBPageNav>
        </MDBPageItem>
      </MDBPagination>
    </>
  );
};

export default ProductsList;
